import { baseInstance } from '@/apis';

const { post: basePost } = baseInstance;

// 获取banner列表接口
export const getBannerList = (params) => {
  return basePost('/laoa-admin/pc/banner/page', params);
};
